import { styled } from '@mui/material'
import Button, { ButtonProps } from '@mui/material/Button'
import Icon from '@mui/material/Icon'
import React from 'react'

import Tooltip from '@/app/component/atom/tooltip'
import { pzListToArray } from '@/app/module/utils/personalization'
import { PersonalizationType, SinglePersonalizationType } from '@/app/types'

type AddButtonProps = {
  disabled?: boolean
  icon: string
  size?: ButtonProps['size']
  text: string
  tooltip: string
  onClick: React.MouseEventHandler<HTMLButtonElement>
}

export const CampaignAddButton: React.FC<AddButtonProps> = ({ disabled, icon, size, text, tooltip, onClick }) => {
  if (!tooltip) {
    return (
      <span>
        <StyledButton
          className="campaign-item-content-add-button"
          color={'primary'}
          disabled={disabled}
          size={size}
          startIcon={<Icon>{icon}</Icon>}
          variant="contained"
          onClick={onClick}
        >
          {text}
        </StyledButton>
      </span>
    )
  }

  return (
    <Tooltip title={<span style={{ display: 'block', textAlign: 'center' }}>{tooltip}</span>}>
      <span>
        <StyledButton
          className="campaign-item-content-add-button"
          color={'primary'}
          disabled={disabled}
          size={size}
          startIcon={<Icon>{icon}</Icon>}
          variant="contained"
          onClick={onClick}
        >
          {text}
        </StyledButton>
      </span>
    </Tooltip>
  )
}

const StyledButton = styled(Button)({
  minWidth: '0',
  padding: '8px',
  margin: 'auto',
})

export const SUPPORTED_ACTION_TYPES = [
  'sms',
  'sendSMSToPhoneNumbers',
  'transfer',
  'api',
  'topup',
  'updateContact',
  'sendEmail',
  'sendWhatsapp',
  'voice',
  'subscribeToCampaign',
]

export const mapPZBy = (personalizationList: PersonalizationType, key: 'label' | 'value') =>
  pzListToArray(personalizationList).reduce<Record<string, SinglePersonalizationType>>(
    (map, pzItem) => ({
      ...map,
      [pzItem[key]]: pzItem,
    }),
    {},
  )
